import {useEffect, useRef} from "react";
import videojs from "video.js";
import 'video.js/dist/video-js.css';
import {Box} from "@mui/material";

type SOURCETYPES = 'video/mp4' | 'application/x-mpegURL'

interface VideoJSPlayerProps {
    url: string;
    sourceType: SOURCETYPES;
}

const VideoJSPlayer = ({url, sourceType} : VideoJSPlayerProps) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const playerRef = useRef<any>(null);

    const onVideoLoaded = () => {
        playerRef.current.play();
    }

    const initPlayer = () => {
        if (videoRef && videoRef.current && url && !playerRef.current) {
            playerRef.current = videojs(videoRef.current, {
                controls: true,
                preload: 'auto',
                liveui: true,
                sources: [{
                    src: url,
                    type: sourceType
                }]
            });
            playerRef.current.on('canplay', onVideoLoaded);

        }
    }

    useEffect(() => {
        initPlayer();
        if (!url && playerRef.current){
            playerRef.current.pause()
            playerRef.current.dispose();
            playerRef.current = null;
        }
    }, [url]);

    return (
    <Box sx={{width: '100%'}}>
            <video ref={videoRef}
                   style={{
                       position: 'absolute',

                       height:'85vh', width:'calc((85vh/9)*16)'
                   }}
                   className="video-js vjs-live vjs-liveui" controls preload="auto"></video>
    </Box>
    );
};
export default VideoJSPlayer;